var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-panel__navigation"},[_c('div',{staticClass:"admin-panel__navigation-item"},[_c('router-link',{attrs:{"to":{ name: 'admin-panel-users' }}},[_vm._v("Users")])],1),_c('div',{staticClass:"admin-panel__navigation-item"},[_c('router-link',{attrs:{"to":{ name: 'admin-panel-promo' }}},[_vm._v("Promo")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }